import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faMicrophoneSlash, faVolumeSlash } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedUser } from '../../../shared/models/user';
import { muteStateOf } from '../../../shared/helpers/mute-state';
import { OdinService } from '../../services/odin.service';

/**
 * A user's mute icon, or nothing while they can talk. The host is hidden
 * while unmuted so it takes no space (or flex gap) next to a name. Size and
 * color follow the host's `font-size` and `color`.
 */
@Component({
  selector: 'andor-mute-status',
  standalone: true,
  imports: [FaIconComponent, TranslatePipe],
  templateUrl: './mute-status.html',
  styleUrl: './mute-status.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.muted]': '!!state()' },
})
export class MuteStatus {
  private readonly odin = inject(OdinService);

  user = input.required<SharedUser>();

  protected readonly state = computed(() => muteStateOf(this.user(), this.odin.hasAudioInput()));

  protected readonly faVolumeSlash = faVolumeSlash;
  protected readonly faMicrophoneSlash = faMicrophoneSlash;
}
